import type { ButtonHTMLAttributes, MouseEventHandler } from "react"

import CloseButton from "./CloseButton"

export type CloseButtonTone =
  | "info"
  | "success"
  | "warning"
  | "alert"
  | "neutral"

export type CloseButtonVariant = "surface" | "transparent"

export interface Props extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "type"
> {
  iconSize?: string
  label: string
  onClick?: MouseEventHandler<HTMLButtonElement>
  size?: number
  tone?: CloseButtonTone
  type?: "button" | "submit" | "reset"
  variant?: CloseButtonVariant
  customColor?: string
}

export interface ComponentProps extends Props {}

export default CloseButton
